"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionNameMap = void 0;
const schema = {
    schemaType: "object",
    properties: [
        {
            title: "タイプ",
            propertyName: "type",
            schema: {
                schemaType: "selector",
                options: [
                    {
                        title: "更新",
                        value: "action",
                    },
                    {
                        title: "アップロード",
                        value: "upload",
                    },
                    {
                        title: "差分更新/新規作成",
                        value: "merge",
                    },
                    {
                        title: "全体更新/新規作成",
                        value: "set",
                    },
                    {
                        title: "更新",
                        value: "update",
                    },
                    {
                        title: "削除",
                        value: "delete",
                    },
                    {
                        title: "リストア",
                        value: "restore",
                    },
                ],
            },
        },
        {
            title: "翻訳プロジェクト",
            propertyName: "constraint.projectId",
            schema: {
                schemaType: "externalKey",
                resourcePath: "/project",
                titleKey: "projectName",
                staticOptions: [
                    {
                        value: "default",
                        title: "システム",
                    },
                ],
            },
        },
        {
            title: "対象",
            propertyName: "collectionName",
            schema: {
                schemaType: "selector",
                options: [
                    {
                        title: "店舗",
                        value: "shop",
                    },
                    {
                        title: "調査",
                        value: "survey",
                    },
                    {
                        title: "リワード",
                        value: "reward",
                    },
                    {
                        title: "メールテンプレート",
                        value: "mailTemplate",
                    },
                    {
                        title: "レポート",
                        value: "report",
                    },
                    {
                        title: "翻訳プロジェクト",
                        value: "project",
                    },
                    {
                        title: "複数",
                        value: null,
                    },
                ],
            },
        },
        {
            title: "ユーザ",
            propertyName: "userId",
            schema: {
                schemaType: "externalKey",
                resourcePath: "/adminUser",
                titleKey: "name",
            },
        },
        {
            title: "件数",
            propertyName: "count",
            schema: {
                schemaType: "number",
            },
        },
        {
            title: "作成件数",
            propertyName: "summary.created",
            schema: {
                schemaType: "number",
            },
        },
        {
            title: "更新件数",
            propertyName: "summary.updated",
            schema: {
                schemaType: "number",
            },
        },
        {
            title: "削除件数",
            propertyName: "summary.deleted",
            schema: {
                schemaType: "number",
            },
        },
        {
            title: "無効件数",
            propertyName: "summary.noop",
            schema: {
                schemaType: "number",
            },
        },
        {
            title: "作成日時",
            propertyName: "createdAt",
            schema: {
                schemaType: "datetime",
            },
        },
        {
            title: "更新日時",
            propertyName: "updatedAt",
            schema: {
                schemaType: "datetime",
            },
        },
    ],
};
exports.default = schema;
const collectionNameSchema = (_a = schema.properties.find((p) => p.propertyName === "collectionName")) === null || _a === void 0 ? void 0 : _a.schema;
exports.collectionNameMap = Object.fromEntries(collectionNameSchema.options.map((o) => [o.value, o.title]));
